import { PromotionsProp } from '../models/sectionPromotions'

import imgCard1 from '../assets/card/lendas colecionaveis.png'
import imgCard2 from '../assets/card/gpsp 25.png'
import imgCard3 from '../assets/card/tanque cheio de premios.png'
import imgCard4 from '../assets/card/gpsp 24.png'
import imgCard5 from '../assets/card/shell helix.png'
import imgCard6 from '../assets/card/gpsp 23.png'
import imgCard7 from '../assets/card/junte e troque - curta a vida onde estiver.png'
import imgCard8 from '../assets/card/junte e troque - no seu ritmo.png'
import imgCard9 from '../assets/card/menos 15.png'
import imgCard10 from '../assets/card/junte e ganhe.png'
import imgCard11 from '../assets/card/junte e troque - curta a vida no seu ritmo.png'
import imgCard12 from '../assets/card/unboxing shell na caixa.png'
import imgCard13 from '../assets/card/embarque num sonho.png'

export interface ForYourVehicleProps {
    headline: {
        title: string
        text: string
    }
}

export const getPromotions = async (): Promise<PromotionsProp> => {
  return Promise.resolve([
    {
        title: "Promoções",
        description: "Campanhas ativas e anteriores para você acompanhar, participar e aproveitar no momento certo.",
        promotions: [
            {
                id: '1',
                title: 'Shell e Scuderia Ferrari HP Lendas colecionáveis',
                images: imgCard1,
                actions: [
                    {
                        title: 'Saiba mais',
                        url: 'https://promo.shell.com.br/colecionaveis/'
                    }
                ]
            },
            {
                id: '2',
                title: 'V-iva a emoção das pistas no Grande Prêmio de SP 2025',
                images: imgCard2,
                actions: [
                    {
                        title: 'Saiba mais',
                        url: 'https://promo.shell.com.br/experiencias/'
                    }
                ]
            },
            {
                id: '3',
                title: 'Tanque cheio de Prêmios',
                images: imgCard3,
                actions: [
                    {
                        title: 'Saiba mais',
                        url: 'https://promo.shell.com.br/etanol/'
                    }
                ]
            },
            {
                id: '4',
                title: 'V-iva a emoção das pistas no Grande Prêmio de SP 2024',
                images: imgCard4,
                actions: [
                    {
                        title: 'Saiba mais',
                        url: ''
                    }
                ]
            },
            {
                id: '5',
                title: 'Você pede mais. Seu carro pede Shell Helix',
                images: imgCard5,
                actions: [
                    {
                        title: 'Saiba mais',
                        url: ''
                    }
                ]
            },
            {
                id: '6',
                title: 'V-ocê no Grande Prêmio de São Paulo 2023',
                images: imgCard6,
                actions: [
                    {
                        title: 'Saiba mais',
                        url: ''
                    }
                ]
            },
            {
                id: '7',
                title: 'Junte & Troque curta a vida onde estiver',
                images: imgCard7,
                actions: [
                    {
                        title: 'Saiba mais',
                        url: ''
                    }
                ]
            },
            {
                id: '8',
                title: 'Junte & Troque no seu ritmo',
                images: imgCard8,
                actions: [
                    {
                        title: 'Saiba mais',
                        url: ''
                    }
                ]
            },
            {
                id: '9',
                title: 'Menos 15',
                images: imgCard9,
                actions: [
                    {
                        title: 'Saiba mais',
                        url: ''
                    }
                ]
            },
            {
                id: '10',
                title: 'Junte & Ganhe com Shell Box',
                images: imgCard10,
                actions: [
                    {
                        title: 'Saiba mais',
                        url: ''
                    }
                ]
            },
            {
                id: '11',
                title: 'Junte & Troque curta a vida no seu ritmo',
                images: imgCard11,
                actions: [
                    {
                        title: 'Saiba mais',
                        url: ''
                    }
                ]
            },
            {
                id: '12',
                title: 'Unboxing Shell na Caixa',
                images: imgCard12,
                actions: [
                    {
                        title: 'Saiba mais',
                        url: ''
                    }
                ]
            },
            {
                id: '13',
                title: 'Promoção Embarque num sonho',
                images: imgCard13,
                actions: [
                    {
                        title: 'Saiba mais',
                        url: ''
                    }
                ]
            },
        ]
    }
  ])
}